import React from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/button';
import Modal from 'components/modal';
import { getListingLabel, getListingTypeLabel } from './helpers';

export default function DealCreationSuccess({ deal, listing, onClose }) {
  let suffix;
  const label = getListingLabel(listing);
  if (label) {
    suffix = <b>{label}</b>;
  } else {
    suffix = <span>the <b>{getListingTypeLabel(listing)}</b> listing</span>;
  }

  return (
    <Modal show>
      <Modal.Header>
        Deal Created
      </Modal.Header>

      <Modal.Body>
        <p>Deal <b>{deal.identifier}</b> was successfully created for {suffix}.</p>
      </Modal.Body>

      <Modal.Footer>
        <Button.Primary onClick={onClose}>
          Ok
        </Button.Primary>
      </Modal.Footer>
    </Modal>
  );
}

DealCreationSuccess.propTypes = {
  deal: PropTypes.shape({
    identifier: PropTypes.string.isRequired,
  }).isRequired,
  listing: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};
